import React, { useState } from "react";
import { createPortal } from "react-dom";

const CollapsedHint = ({ label, children, disabled = false }) => {
  const [pos, setPos] = useState(null);

  if (disabled || !label) return children;

  const show = event => {
    const rect = event.currentTarget.getBoundingClientRect();
    setPos({
      top: rect.top + rect.height / 2,
      left: rect.right + 10,
    });
  };

  return (
    <>
      <div
        className='w-full'
        onMouseEnter={show}
        onMouseLeave={() => setPos(null)}
        // Some dropdown interactions keep the pointer technically "within" the
        // wrapper, so ensure the tooltip is cleared on click as well.
        onMouseDown={() => setPos(null)}
        onClick={() => setPos(null)}>
        {children}
      </div>
      {pos &&
        createPortal(
          <div
            role='tooltip'
            className='fixed z-[80] pointer-events-none px-2 py-1 rounded-md bg-grey-900 text-white text-xs font-medium shadow-lg whitespace-nowrap'
            style={{
              top: pos.top,
              left: pos.left,
              transform: "translateY(-50%)",
            }}>
            {label}
          </div>,
          document.body,
        )}
    </>
  );
};

export default CollapsedHint;
